var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';
import { classNames, cn } from '../../utils/cn';
var cls = classNames('entity-select');
import { breakpoints, theme } from '@shapeable/theme';
import { EntityBaseSelect } from './entity-base-select';
import { EntitySelectOptionWithDescriptions } from './entity-select-option';
import { EntitySelectSingleValue, EntitySelectValue } from './entity-select-value';
import { EntitySelectMultiValue } from './entity-select-multi-value';
import { sprintf } from 'sprintf-js';
import { Icons } from '../icons';
import { withOwnProvider } from '../../utils/with-own-provider';
export var entitySelectDefaultTransform = function entitySelectDefaultTransform(entity) {
  return {
    value: entity.id,
    label: entity.name,
    entity: entity
  };
};
export var EntitySelectDefaultProps = {
  debounceInterval: 250,
  pageSize: 50,
  options: [],
  colorVariant: "default",
  loadOptionsOnMenuOpen: true,
  defaultOptions: true,
  isSearchable: true,
  isClearable: true,
  transform: entitySelectDefaultTransform
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    button.ellipsis-button {\n      visibility: hidden !important;\n    }\n\n    ", "\n    \n    &:hover {\n      ", "\n    }\n\n  "], ["\n    button.ellipsis-button {\n      visibility: hidden !important;\n    }\n\n    ", "\n    \n    &:hover {\n      ", "\n    }\n\n  "])), function (props) {
    return props.colorVariant === "inverted" && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      * {\n        color: ", ";\n      }\n\n      .shp--entity-select__menu {\n        background: ", ";\n      }\n\n    "], ["\n      * {\n        color: ", ";\n      }\n\n      .shp--entity-select__menu {\n        background: ", ";\n      }\n\n    "])), theme.COLOR('light'), theme.COLOR('dark'));
  }, function (props) {
    return props.showEditMenu && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        button.ellipsis-button {\n          visibility: visible !important;\n        }\n      "], ["\n        button.ellipsis-button {\n          visibility: visible !important;\n        }\n      "])));
  })
});
var SingleValueStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-left: 1px;\n  "], ["\n    padding-left: 1px;\n  "])))
});
var MultiValueStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  "], ["\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled(EntityBaseSelect)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  SingleValue: styled(EntitySelectValue)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), SingleValueStyles),
  MultiValue: styled(EntitySelectMultiValue)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), MultiValueStyles)
};
export var EntitySelect = function EntitySelect(props) {
  var className = props.className,
      debounceInterval = props.debounceInterval,
      pageSize = props.pageSize,
      isMulti = props.isMulti,
      transform = props.transform,
      showEditMenu = props.showEditMenu,
      colorVariant = props.colorVariant,
      items = props.items,
      selectProps = __rest(props, ["className", "debounceInterval", "pageSize", "isMulti", "transform", "showEditMenu", "colorVariant", "items"]);

  var entityTypeName = props.entityTypeName; // @ts-ignore

  var Icon = entityTypeName && Icons.Entities[entityTypeName] || Icons.SearchCircle;
  var searchIconSize = isMulti ? 36 : 48;

  var components = __assign({
    Option: EntitySelectOptionWithDescriptions,
    Value: EntitySelectValue,
    SingleValue: EntitySelectSingleValue,
    MultiValue: EntitySelectMultiValue
  }, props.components || {});

  var styles = useMemo(function () {
    return __assign({}, props.styles);
  }, []);
  var placeholder = props.placeholder || (isMulti ? sprintf('Select one or more %s...', props.pluralLabel || '') : sprintf('Select %s...', props.aLabel || 'one'));
  return React.createElement(My.Container, __assign({
    colorVariant: colorVariant,
    showEditMenu: showEditMenu
  }, selectProps, {
    styles: styles,
    classNamePrefix: cn('entity-select'),
    options: items.map(transform),
    searchIconColor: "text-subtle",
    searchIcon: React.createElement(Icon, null),
    searchIconSize: searchIconSize,
    className: cls.name(className),
    isMulti: isMulti,
    components: components,
    placeholder: placeholder,
    padOptions: false
  }));
};
EntitySelect.defaultProps = EntitySelectDefaultProps;
EntitySelect.cls = cls;
export var EntitySelectReplaceable = withOwnProvider(EntitySelect);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;